import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react'

const FormModalCreatePropietario = ({ onSave, initialData }) => {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [cedula, setCedula] = useState('');

    const submit = e => {
        e.preventDefault();
        if (!nombre.trim() || !email.trim() || !celular.trim()) {
            // Puedes usar una alerta aquí si tienes una librería como Swal
            alert('Debe completar todos los campos: Nombre, Email y Celular');
            return;
        }
        onSave({ nombre, email, celular, cedula });
    };

    useEffect(() => {
        if (initialData) {
            console.log('Cargando datos iniciales:', initialData)
            setNombre(initialData.nombre || '')
            setEmail(initialData.email || '')
            setCelular(initialData.celular || '')
            setCedula(initialData.cedula || '')
        }
    }, [initialData]);
    return (
        <>

            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Cédula</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Cédula"
                        value={cedula}
                        onChange={e => setCedula(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Nombre</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nombre completo"
                        value={nombre}
                        onChange={e => setNombre(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Email</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Correo electrónico"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Celular</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Número de teléfono"
                        value={celular}
                        onChange={e => setCelular(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>
            <div className="d-flex justify-content-end">
                <button className='btn-primary-modals-maestros' onClick={submit}>
                    Guardar
                </button>
            </div>
        </>
    )
}

export default FormModalCreatePropietario
